import React, { useState } from "react";
import AddCard from "../../components/buttons/AddCard";
import PointsList from "./pointsList";

const PointsSetUp = () => {
  const [search, setSearch] = useState("");

  return (
    <>
      <div className="courseSetUp">
        <div className="topList">
          <h2 className="top-heading">Add New Card</h2>
          <div className="search-inp">
            <button type="submit">search</button>
            <input
              className="dashboard-search"
              type="search"
              placeholder="Search Card..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <AddCard />
        </div>
        <PointsList search={search} />
      </div>
    </>
  );
};

export default PointsSetUp;
